import chartConfig1 from './chartConfig1.json'
import chartConfig2 from './chartConfig2.json'

export enum E_ANALYSIS_CHART {
    TECHNICAL_PROBLEM = 'technical_problem',
    TECH_DOMAIN_WORD_CLOUD = 'tech_domain_word_cloud',
    APD_Y_BENEFIT_THEME = 'apd_y_benefit_theme',
    APD_Y_BENEFIT_PHRASE = 'apd_y_benefit_phrase',
    BENEFIT_THEME_BENEFIT_PHRASE = 'benefit_theme_benefit_phrase',
    ANCS_BENEFIT_PHRASE = 'ancs_benefit_phrase',
    // 技术效果*应用领域(三级
    BENEFIT_PHRASE_ADC_C = 'benefit_phrase_adc_c'
}

export interface IResultChart {
    img?: any,
    chartType: E_ANALYSIS_CHART,
    titleKey: string,
    descKey: string,
    config: any,
}

export const resultCharts: IResultChart[] = [{
    // img: chart2.id,
    chartType: E_ANALYSIS_CHART.TECH_DOMAIN_WORD_CLOUD,
    titleKey: `analysis.charts.${E_ANALYSIS_CHART.TECH_DOMAIN_WORD_CLOUD}.title`,
    descKey: `analysis.charts.${E_ANALYSIS_CHART.TECH_DOMAIN_WORD_CLOUD}.desc`,
    config: chartConfig1,
}, {
    // img: chart1.id,
    chartType: E_ANALYSIS_CHART.TECHNICAL_PROBLEM,
    titleKey: `analysis.charts.${E_ANALYSIS_CHART.TECHNICAL_PROBLEM}.title`,
    descKey: `analysis.charts.${E_ANALYSIS_CHART.TECHNICAL_PROBLEM}.desc`,
    config: chartConfig2,
}];
